/**
 * Base class for application errors.
 */
export default abstract class BaseError extends Error {
  readonly name: string = "BaseError";
  readonly cause: Error | null;
  constructor(message: string, cause: Error | null = null) {
    super(message)
    this.cause = cause;
  }
}
